import type { AvailabilityBlockReason } from '@/entities/Tree';

export const DOCUMENT_LOCK_MESSAGES: Record<AvailabilityBlockReason, string> = {
  dsb_check: 'Документ проверяется службой информационной безопасности. Просмотр и скачивание пока недоступны.',
  processing: 'Документ обрабатывается. Попробуйте открыть его позже.',
  processing_error: 'Обработка документа завершилась с ошибкой. Просмотр недоступен.',
};

/** Текст тултипа у папки с недоступным содержимым (не путать с личной папкой и не дублировать текст про один документ). */
export const FOLDER_LOCK_MESSAGES: Record<AvailabilityBlockReason, string> = {
  dsb_check:
    'В папке есть документы на проверке службой информационной безопасности. Просмотр и скачивание пока недоступны.',
  processing: 'В папке есть документы в обработке. Попробуйте открыть содержимое позже.',
  processing_error: 'Обработка документов в папке завершилась с ошибкой. Просмотр содержимого недоступен.',
};

export const DOCUMENT_LOCK_BADGE_LABELS: Record<AvailabilityBlockReason, string> = {
  dsb_check: 'Проверяется',
  processing: 'Обрабатывается',
  processing_error: 'Ошибка',
};

export function getDocumentLockMessage(reason: AvailabilityBlockReason | null | undefined): string {
  if (!reason) {
    return 'Документ временно недоступен.';
  }

  return DOCUMENT_LOCK_MESSAGES[reason];
}

export function getFolderLockMessage(reason: AvailabilityBlockReason | null | undefined): string {
  if (!reason) {
    return 'Содержимое папки временно недоступно.';
  }

  return FOLDER_LOCK_MESSAGES[reason];
}

/** Короткая подпись для aria / тултипа иконки недоступности. */
export function getDocumentLockBadgeLabel(reason: AvailabilityBlockReason | null | undefined): string {
  if (!reason) {
    return 'Недоступен';
  }

  return DOCUMENT_LOCK_BADGE_LABELS[reason];
}
